import { loadingController} from '@ionic/vue';


export const Loading = async (message = 'Cargando...') =>(
    loadingController.create({
        message,
        spinner: 'circles'
    }
))